import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "js-page-content",
  role: "main",
  class: "page-content"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "subheader" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "subheader-title" }, "データポータル")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("ul", {
    class: "nav nav-pills nav-justified",
    role: "tablist"
  }, [
    /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
      /*#__PURE__*/_createElementVNode("a", {
        class: "nav-link",
        "data-toggle": "tab",
        href: "#js_change_pill_justified-1"
      }, "分析ダッシュボード")
    ]),
    /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
      /*#__PURE__*/_createElementVNode("a", {
        class: "nav-link",
        "data-toggle": "tab",
        href: "#js_change_pill_justified-2"
      }, "売上分析")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "tab-content py-3" }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "tab-pane fade",
      id: "js_change_pill_justified-1",
      role: "tabpanel"
    }, " Raw denim you probably haven't heard of them jean shorts Austin. Nesciunt tofu stumptown aliqua, retro synth master cleanse. Mustache cliche tempor, williamsburg carles vegan helvetica. Reprehenderit butcher retro keffiyeh dreamcatcher synth. Cosby sweater eu banh mi, qui irure terry richardson ex squid. Aliquip placeat salvia cillum iphone. "),
    /*#__PURE__*/_createElementVNode("div", {
      class: "tab-pane fade",
      id: "js_change_pill_justified-2",
      role: "tabpanel"
    }, " Food truck fixie locavore, accusamus mcsweeney's marfa nulla single-origin coffee squid. Exercitation +1 labore velit, blog sartorial PBR leggings next level wes anderson artisan four loko farm-to-table craft beer twee. Qui photo booth letterpress, commodo enim craft beer mlkshk aliquip jean shorts ullamco ad vinyl cillum PBR. Homo nostrud organic. ")
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, _hoisted_4))
}